import { lazy } from 'react';
import { Outlet, RouteObject } from 'react-router-dom';
import { AccessControlLayout, ChatLayout, GuestLayout } from '@/layouts';
import { ERouterNames, EUserRoles } from '@/types';

const GuestInvitation = lazy(() => import('../pages/GuestInvitation'));
const Chat = lazy(() => import('../pages/Chats/pages/Chat'));
const Encounter = lazy(() => import('../pages/Encounters/pages/Encounter'));
const WaitingRoom = lazy(
  () => import('../pages/WaitingRooms/pages/WaitingRoom'),
);
const SessionEnded = lazy(() => import('../pages/SessionEnded'));
const FormBuilderEntry = lazy(
  () => import('@/pages/FormBuilderEntries/pages/FormBuilderEntry'),
);

export const guestRouters: RouteObject[] = [
  {
    path: ERouterNames.INVITE_BY_TOKEN,
    element: <GuestInvitation />,
  },
  {
    path: ERouterNames.GUEST,
    element: <GuestLayout />,
    children: [
      {
        element: <AccessControlLayout roles={[EUserRoles.GUEST]} />,
        children: [
          {
            element: <ChatLayout />,
            children: [
              {
                path: ERouterNames.WAITING_ROOM,
                element: <Outlet />,
                children: [
                  {
                    index: true,
                    element: <WaitingRoom />,
                  },
                  {
                    path: ERouterNames.LEFT,
                    element: <SessionEnded variant="waitingRoom" />,
                  },
                ],
              },
              {
                path: ERouterNames.CHAT,
                element: <Outlet />,
                children: [
                  {
                    index: true,
                    element: <Chat />,
                  },
                  {
                    path: ERouterNames.SESSION_ENDED,
                    element: <SessionEnded variant="session" />,
                  },
                ],
              },
              {
                path: ERouterNames.ENCOUNTER,
                element: <Outlet />,
                children: [
                  {
                    index: true,
                    element: <Encounter />,
                  },
                  {
                    path: ERouterNames.SESSION_ENDED,
                    element: <SessionEnded variant="session" />,
                  },
                ],
              },
              {
                path: ERouterNames.GUEST_FORM_BUILDER_ENTRY_VIEW,
                element: <FormBuilderEntry variant="view" />,
              },
            ],
          },
        ],
      },
    ],
  },
];
